import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setInfoContent } from "../../redux/slices/common_slice";

export default function GeneralInfoModal() {
  const dispatch = useDispatch();
  const modalContent = useSelector((state) => state.common.infoContent);

  const handleClose = () => {
    dispatch(setInfoContent(""));
  };
  return (
    <Modal
      width="385px"
      title=""
      open={modalContent ? true : false}
      onOk={handleClose}
      onCancel={handleClose}
      footer={false}
      centered
      closeIcon={
        <img
          src="/assets/images/icons/close-icon-modal.svg"
          alt=""
          className="img-fluid"
        />
      }
      className="custom-common-modal information-modal"
    >
      <p
        className="mb-0"
        dangerouslySetInnerHTML={{ __html: modalContent }}
      ></p>
    </Modal>
  );
}
